export const INITIATIVES_TABLE_LABELS = {
	ACTION: 'Action',
	ASSIGNED_TO: 'Assigned To',
	CREATED_ON: 'Created On',
	NO_DATA: 'No matching Initiatives found.',
	STATUS: 'Status',
	TITLE: 'Title',
	TYPE: 'Type'
};
